import { Components, Theme } from '@mui/material';

export const MuiDrawerTheme = (): Components<Theme>['MuiDrawer'] => {
  return {
    defaultProps: {
      disableEnforceFocus: false,
      disableScrollLock: false,
    },
    styleOverrides: {
      root: {
        // MUI Drawer base styles
      },
      paper: {
        // Override paper styles to match pounce SideSheet behavior
        boxShadow: 'none', // shadow is applied via Box component inside
      },
      modal: {
        // Override backdrop to match pounce overlay behavior
        overflow: 'visible',
      },
    },
  };
};
